module.exports = __webpack_public_path__ + "next.02a33a1e.png";